
import imgEmpty from '../../assets/images/imgEmpty.png';

export default function MyCustomNoRowsOverlay() {
  return (
    <img src={imgEmpty} alt="no-item" style={{borderRadius: '2rem'}} />
  )
}